var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center",staticStyle:{"gap":"6px"}},[_c('span',[_vm._v(_vm._s(_vm.params.value))]),_c('GrWunschIcon',{attrs:{"teilnehmers":_vm.params.data?.teilnehmers ?? []}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }